export default {
  getLinks: (state) => state.links,
  getChatThread: (state) => state.chatThread,
  getChatData: (state) => state.chatData,
  getFormData: (state) => state.formData,
  getLastMessageReceived: (state) => state.lastMessageReceived,
  isFinished: (state) => state.isFinished,
};
